import { ApiHelper } from 'src/cad/common/services/api/api-helper';
import { Observable } from 'rxjs';
import { UserModelService } from 'src/cad/common/services/user/user-model-service';
import { Injectable } from '@angular/core';
import { ContractedCapacity } from 'src/cad/capacity-analysis/interfaces/contracted-capacity';

@Injectable()
export class ContractedCapacityApi{
  private readonly endpoint: string = 'capacity-analysis/contracted-capacity';
  constructor(
    private apiHelper: ApiHelper,
    private userModelService: UserModelService ) {
  }

  public getContractedCapacity(dirOfFlow: string, physicalTypeCd: string, physicalCd: string, effBeginDt: string, assetNbr: number, effEndDt: string): Observable<ContractedCapacity[]> {
    const reqObj = {
      dirOfFlow, physicalTypeCd, physicalCd, effBeginDt, assetNbr: this.userModelService.getCurrentContext().assetNbr, effEndDt
    };
    return this.apiHelper.request(this.endpoint, { body: reqObj });
  }
}
